import React from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Navigation = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="fixed top-0 w-full bg-slate-950/80 backdrop-blur-md border-b border-slate-800 z-50" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <img src="/nexus-logo.png" alt="Nexus Creative Group LLC" className="h-14 w-14" data-testid="company-logo-image" />
            <span className="text-xl font-bold text-white" data-testid="company-logo-text">Nexus Creative Group LLC</span>
          </div>
          <div className="hidden md:flex space-x-8">
            <button onClick={() => scrollToSection('about')} className="text-slate-300 hover:text-white transition-colors" data-testid="nav-about-link">About</button>
            <button onClick={() => scrollToSection('portfolio')} className="text-slate-300 hover:text-white transition-colors" data-testid="nav-portfolio-link">Portfolio</button>
            <button onClick={() => scrollToSection('services')} className="text-slate-300 hover:text-white transition-colors" data-testid="nav-services-link">Services</button>
            <button onClick={() => scrollToSection('contact')} className="text-slate-300 hover:text-white transition-colors" data-testid="nav-contact-link">Contact</button>
          </div>
          <Button onClick={() => scrollToSection('contact')} className="bg-blue-600 hover:bg-blue-700" data-testid="nav-cta-button">
            Get Started
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;